import { adminRequests } from 'api/request';
import urls from 'configs/urls';

export const addPost = ({ profileKey, data }) =>
  adminRequests.post(null, false, `${urls.postsUrls.addPost(profileKey)}`, data);

export const getPosts = ({ profileKey, nextQuery, queryData }) => {
  const queryArr = Object.keys(queryData).map(query => `${query}=${queryData[query]}`);
  const queryStr = queryArr.join('&');

  return adminRequests.get(
    null,
    false,
    `${urls.postsUrls.getPosts(profileKey)}?${queryStr}${nextQuery || ''}`,
  );
};

export const deletePost = ({ postKey }) =>
  adminRequests.delete(null, false, urls.postsUrls.deletePost(postKey), null);

export const addRssChannel = ({ data }) =>
  adminRequests.post(null, false, urls.postsUrls.addRssChannel, data);

export const editRssChannel = ({ data }) =>
  adminRequests.patch(null, false, urls.postsUrls.editRssChannel, data);

export const getRssChannels = ({ data }) =>
  adminRequests.get(null, false, urls.postsUrls.getRssChannels, data);
